import { isNoiseError } from './sentry-noise-filter';

// Session Replay is capped at ~50 recordings/month org-wide. Blanket session
// sampling is disabled everywhere (replaysSessionSampleRate: 0); this gates
// the remaining error-triggered replays so the budget goes to first-seen,
// non-noise errors instead of being burned on repeats or known noise.
const replayedFingerprints = new Set<string>();

function fingerprintOf(event: any): string {
  const exc = event.exception?.values?.[0];
  if (exc) return `${exc.type ?? ''}:${exc.value ?? ''}`;
  return event.message ?? 'unknown';
}

export function shouldSampleReplayForError(event: any): boolean {
  if (isNoiseError(event)) {
    return false;
  }

  const key = fingerprintOf(event);
  if (replayedFingerprints.has(key)) {
    return false;
  }
  replayedFingerprints.add(key);
  return true;
}
